import { render, staticRenderFns } from "./summary-info.html?vue&type=template&id=1f54d198&scoped=true&external"
import script from "./summary-info.js?vue&type=script&lang=js&external"
export * from "./summary-info.js?vue&type=script&lang=js&external"
import style0 from "./summary-info.scss?vue&type=style&index=0&id=1f54d198&prod&lang=scss&scoped=true&external"
import style1 from "../swiperBundle/swiper-bundle.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f54d198",
  null
  
)

export default component.exports